import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { assertionClient } from '../client/assertionClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useAssertionsResultsQuery = (options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.answerAssertionsResults],
    queryFn: assertionClient.getAssertionsResults,
  });

  return {
    ...rest,
    results: {
      disciplines: 0,
      majors: 0,
      universities: 0,
      ...data,
    },
  };
};
